// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__FCoay","row":"Node_row__oiNUy","label":"Node_label__29Tfm","footer":"Node_footer__1gS8B"};